import { ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { representativesAllowedUrls } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useDispatchApp } from 'Hooks';
import { setFakeUser, setImposterId } from 'Store';
import { getIsLawyer } from 'Utils/lawyers';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const CustomToggleButtons = () => {
  const isCurrentlyLawyer = sessionStorage.getItem('isLawyer') === 'true';
  const dispatch = useDispatchApp();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Lawyers);
  const navigate = useNavigate();

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    value: boolean | null
  ) => {
    if (value !== null) {
      sessionStorage.setItem('isLawyer', value.toString());
      navigate(value ? '/lawyers-lobby' : '/');
      if (!value) {
        dispatch(setImposterId(''));
        dispatch(setFakeUser({}));
      }
    }
  };

  useEffect(() => {
    if (getIsLawyer() && sessionStorage.getItem('isLawyer') === 'true') {
      if (
        !representativesAllowedUrls.some((url) =>
          window.location.pathname.includes(url)
        )
      ) {
        navigate('/lawyers-lobby');
      }
    } else if (window.location.pathname.includes('/lawyers-lobby')) {
      navigate('/');
    }
  }, []);

  return (
    <ToggleButtonGroup
      value={isCurrentlyLawyer}
      exclusive
      onChange={handleChange}
      aria-label={dictionary.switchBetweenLawyersAndUsers}
      sx={{
        alignSelf: 'center',
        bgcolor: 'white',
        borderRadius: '47px',
        border: 0,
        height: '47px !important',
        justifyContent: 'space-between',
        p: '4px',
        gap: '6px',
        boxShadow: '0px -1px 10px 0px #00000012',
      }}
    >
      <ToggleButton
        sx={{
          p: '8px 0px',
          bgcolor: isCurrentlyLawyer === false ? '#A020FF !important' : 'white',
          color:
            isCurrentlyLawyer === false
              ? 'white !important'
              : 'black !important',
          width: '117px',
          border: 0,
          ':hover': { bgcolor: '#A020FF', color: 'white !important' },
          borderRadius: '40px !important',
        }}
        value={false}
      >
        <Typography
          sx={{
            fontSize: '16px !important',
            lineHeight: '24px !important',
            fontWeight: isCurrentlyLawyer === false ? '700' : '400 !important',
            minWidth: 'max-content',
          }}
        >
          {dictionary.personalArea}
        </Typography>
      </ToggleButton>
      <ToggleButton
        sx={{
          p: '8px 0px',
          bgcolor: isCurrentlyLawyer !== false ? '#A020FF !important' : 'white',
          color:
            isCurrentlyLawyer !== false
              ? 'white !important'
              : 'black !important',
          width: '117px',
          border: 0,
          ':hover': { bgcolor: '#A020FF', color: 'white !important' },
          borderRadius: '40px !important',
        }}
        value={true}
      >
        <Typography
          sx={{
            fontSize: '16px !important',
            lineHeight: '24px !important',
            fontWeight: isCurrentlyLawyer ? '700' : '400 !important',
            minWidth: 'max-content',
          }}
        >
          {dictionary.repArea}
        </Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
